import { SelectionWithAddressMixin } from './mixin';
import { SelectionAny } from './internal';
export class SelectionCorporation extends SelectionWithAddressMixin(SelectionAny) {
}
//# sourceMappingURL=SelectionCorporation.js.map